import { inject } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { CanActivateFn, Router } from "@angular/router";
import { filter, map, take } from "rxjs";
import { UserService } from "../services/user.service";

export const authGuard: CanActivateFn = (route, state) => {
  // return true;
  const router = inject(Router);
  const userService = inject(UserService);
  return toObservable(userService.initCompleted).pipe(
    filter((completed) => completed === true),
    take(1),
    map(() => {
      return userService.isAuthenticated() || router.parseUrl("auth/login");
    })
  );
};
